<script>
    import { Card, CardBody, Spinner } from 'sveltestrap';   
    import OperatingSystem from "../ComputerDashboard/OperatingSystem.svelte"
    import Storage from "../ComputerDashboard/Storage.svelte"
    import Network from "../ComputerDashboard/Network.svelte"
    import Motherboard from "./Motherboard.svelte"
    import { selectedGroup } from '../../store';
    import http from '../../api/http.js';
    import Tabs from "../../layout/Tabs.svelte"
    import Prettysize from 'prettysize';
    export let computerId;

    let overview;
    const storage = "Storage";
    const network = "Network";
    const motherboard = "Motherboard";
    const operatingSystem = "Operating System";
    let tabs = [operatingSystem, storage, network, motherboard]
    let activeTab = operatingSystem;
    const changeTab = (e) => {
    activeTab = e.detail;
  }    

  $: {    
      computerId;
      loadSystemOverview()
    }

    async function loadSystemOverview(){
        const res = await http.get(`${window.apiBaseUrl}/deploy/dashboard/computers/spec/${computerId}/${$selectedGroup}`);
        if(res.status == 200){
            overview = await res.json();
        }
    }
</script>

{#await loadSystemOverview()}
    <Spinner color="primary" type="border"></Spinner>
{:then}
<div id="overview-context">
    <Card>
        <CardBody>
            <div class="row">
                <div class="col-sm">
                    <h5 class="font-weight-bold mt-2 mb-2">General</h5>
                    <div>
                        <label for="processor">Processor:</label>
                        <span id="processor">{overview.processor}</span>
                    </div>
                    <div>
                        <label for="deploy-version">Deploy Version:</label>
                        <span id="deploy-version">{overview.deployVersion}</span>
                    </div>
                    <div>
                        <label for="memory-capacity">Memory:</label>
                        <span id="memory-capacity">{overview.memoryCapacity == 0 ? "Data not available":Prettysize(overview.memoryCapacity)}</span>   
                    </div>   
                    <div>
                        <label for="memory-type">Memory Type:</label>
                        <span id="memory-type">{overview.memoryType}</span>
                    </div>   
                </div>
                <div class="col-sm">
                    <h5 class="font-weight-bold mt-2 mb-2">Operating System</h5>
                    <div>
                        <label for="os-name">Name:</label>
                        <span id="os-name">{overview.osName}</span>
                    </div>
                    <div>
                        <label for="os-build">Build:</label>
                        <span id="os-build">{overview.osBuildNumber}</span>
                    </div>
                    <div>
                        <label for="os-architecture">Architecture:</label>
                        <span id="os-architecture">{overview.osArchitecture}</span>
                    </div>
                    <div>
                        <label for="os-architecture">Language:</label>
                        <span id="os-architecture">{overview.osLanguage}</span>
                    </div>
                </div>
                <div class="col-sm">
                    <h5 class="font-weight-bold mt-2 mb-2">Network</h5>
                    <div>
                        <label for="dns-hostname">DNS Host Name:</label>
                        <span id="dns-hostname">{overview.dnsHostName}</span>
                    </div>
                    <div>
                        <label for="part-of-domain">Part Of Domain:</label>
                        <span id="part-of-domain">{overview.partOfDomain}</span>
                    </div>
                    <div>
                        <label for="domain">Domain:</label>
                        <span id="domain">{overview.domain}</span>
                    </div>  
                    <div>
                        <label for="domain">Workgroup:</label>
                        <span id="domain">{overview.workgroup}</span>
                    </div> 
                </div>
            </div>
        </CardBody>
    </Card>

    <Card class="mt-2">
        <CardBody>
            <div class="d-flex mb-4">
                <div class="ml-auto">
                    <Tabs {tabs}{activeTab} on:tabChange={changeTab}></Tabs>
                </div>    
            </div>
            {#if activeTab == operatingSystem}
                <OperatingSystem {computerId}></OperatingSystem>
            {/if}

            {#if activeTab == storage}
                <Storage {computerId}></Storage>
            {/if}

            {#if activeTab == network}
                <Network {computerId}></Network>
            {/if}

            {#if activeTab == motherboard}
                <Motherboard {computerId}></Motherboard>
            {/if}
        </CardBody>
    </Card> 
</div>   
{/await}

<style>
    #hardware-overview{
        padding: 5px;
        max-height: 80vh;
        overflow-y: auto;
    }

    .group {
    margin: 2rem 0.8rem 2rem 0.8rem;
} 

    .group span {
        color: var(--primary-color);
        font-weight: bold;
    } 

    .group p {
        font-size: 0.8em;
        margin-bottom: 0.4rem;
    }    

    .group label {
        font-size: 14px;
    }    

    label{
        font-weight: 600;
    }
</style>